import { DatePipe } from "@angular/common";
import { takeUntil } from "rxjs";
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject } from "rxjs";
import { HeaderService } from "src/app/components/header/header.service";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { SalesTrendsGridConfigService } from "src/app/data-grid/sales-trends-grid-config.service";
import { ReportsService } from "src/app/services/reports.service";

@Component({
  selector: "app-kpis-sales-graph",
  templateUrl: "./kpis-sales-graph.component.html",
  styleUrls: ["./kpis-sales-graph.component.scss"],
})
export class KpisSalesGraphComponent implements OnChanges,OnDestroy {
  @Input() isDashboard: boolean = false;
  @Input() productId;
  @Input()availableFilters
  @Input()isApplyFilter :boolean=false;
  months: any[] = [];
  private destroy$ = new Subject<void>();
  kpiPerDay: any[] = [];
  mixedChartLabel: any[] =[];
  mixedChartData: any[] = [];
  tickInterval: any[] = [];
  selectedDate = "m";
  loading: boolean = false;
  selectedWeek: any[] = [];
  quartely = this.salesTrendGridConfigService.quartely;
  selectQuaterly = [];
  currentDate: any;
  startDate: any;
  endDate: any;
  date = new Date();
  currentMonth = new Date().getMonth();
  currentYear: number = new Date().getFullYear();
  year = this.date.getFullYear();
  selectedWeekCount: number = 4;
  selectedMonthCount: number = 4;
  selectedQuarterCount: number = 4;
  selectedYearCount: number = 4;
  legends: any[] =[];
  month: any = new Array(
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  );
  mixedChartColor: any[] = [
    "#fd9053",
    "#f1cd2e",
    "#3b6efb",
    "#cb0af1"
  ];
  years: any[] = [];
  leftLagend: any[] = [
    { id: 1, name: "Orders", checked: true, color: "#e26062" },
    { id: 2, name: "Qty Sold", color: "#e26062" }, 
    { id: 3, name: "Return Rate", color: "#9fd0cd" },
    { id: 4, name: "Revenue", color:"#e26062" },
    { id: 5, name: "COGS", color: "#bfddb7" },
    { id: 6, name: "Fees", color: "#3762ff" },
    { id: 7, name: "Profit", color: "#f5c827" },
    { id: 8, name: "Margin", color: "#644a00" },
    { id: 9, name: "ACOS", color: "#c5d39e" },
    { id: 10, name: "TACOS", color: "#e7c69d" },
    { id: 11, name: "Spent", color: "#e26062" },
    { id: 12, name: "Return Amount", color: "#cb0af1" },
    { id: 13, name: "ROI", color: "#b2efdd" }
  ];

  dateForm: FormGroup = new FormGroup({
    selectDate: new FormControl("m")
  });

  dates: any[] = [];
  selectedType: any = 'Orders';
  isFirstDayOfMonth: boolean;

  constructor(
    private reportService: ReportsService,
    private snackBar: MatSnackBar,
    private salesTrendGridConfigService: SalesTrendsGridConfigService,
    private datePipe: DatePipe
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(this.isApplyFilter){
      this.profitComparison();
    }
  }

  ngOnInit(): void {
    this.setMonth();
    this.manageWeaklyDate(false);
    this.setMonthlyDate(true);
    this.setQuarterly();
    this.dateForm.controls["selectDate"]?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.selectedDate = res;
        this.dates = [];
        if(res === 'w'){
          this.setWeeklyDate(true);
        }else if(res === 'm'){
          this.setMonthlyDate(true);
        } else if(res === 'q'){
          this.selectQuartelyDate(true);
        } else{
          this.setYearlyDate(true);
        }
      }
    });
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.years.push({
        name: currentYear - i,
        checked: i < 4 ? true : false,
      });
    }
  }

  // Week

  manageWeaklyDate(isSetWeekly) {
    const nextMonthFirstDay = new Date();
    const lastDateOfMonth = nextMonthFirstDay.getTime();
    this.selectedWeek = [];
    for (let i = 0; i < 52; i++) {
      let today =  new Date();
      let date  = new Date(lastDateOfMonth - this.getDaysAgo(7 * 0));
      if(new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() ==  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()){
        let j = i + 1;
        this.selectedWeek.push({
          label: `${i === 0 ? "This week" : `${i} weeks ago`}`,
          from: new Date(lastDateOfMonth - this.getDaysAgo(7 * j)),
          to: new Date(lastDateOfMonth - this.getDaysAgo(7 * (j - 1))),
          checked: i < 4 ? true : false,
        });  
      } else {
        this.selectedWeek.push({
          label: `${i === 0 ? "This week" : `${i} weeks ago`}`,
          from: new Date(lastDateOfMonth - this.getDaysAgo(7 * i)),
          to: new Date(lastDateOfMonth - this.getDaysAgo(7 * (i - 1))),
          checked: i < 4? true : false,
        });
      }
    }
    this.selectedWeek[this.selectedWeek.length - 1].checked = false;
    this.setWeeklyDate(isSetWeekly);
  }

  selectWeek(event?, selectedDay?, index?) {
    const isCheck = event.checked;
    let checkCount = this.selectedWeek.filter((res)=> res.checked);
    this.selectedWeek.filter((res) => {
      if (event.checked && res.label === selectedDay.label) {
        if (this.selectedWeekCount < 4) {
          res.checked = true;
          this.selectedWeekCount++;
        } else {
          event.source.checked = false;
        }
      } else if (!event.checked && res.label === selectedDay.label) {
        if (this.selectedWeekCount > 1) {
          res.checked = false;
          this.selectedWeekCount--;
        } else {
          event.source.checked = true;
        }
      }
    });
    this.setWeeklyDate(((event.source.checked || !isCheck) && this.selectedWeekCount >= 1 ) && !(checkCount.length == 1 && isCheck == false));
  }

  setWeeklyDate(isValid) {
    this.dates = [];
    this.legends = [];
    this.selectedWeek.forEach((res) => {
      if (res.checked) {
        const weeklyDates = new Date(
          res.from.setHours(0, 0, 0, 0) - res.to.getTimezoneOffset() * 60000
        ).toISOString();

        this.legends.push({name : res.label});

        this.dates.push(weeklyDates);
      }
    });
    if(isValid) this.profitComparison();
  }

  // Month

  setMonth() {
    let checkedCount = 0;
    let monthName: any = new Array(
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    );
    var date = new Date();
    date.setDate(1);
    for (let i: any = 0; i < 14; i++) {
      this.months.push({
        name: monthName[date.getMonth()],
        monthNumber: date.getMonth(),
        year: date.getFullYear(),
        checked: i < 4 ? true : false,
      });
      date.setMonth(date.getMonth() - 1);
    }
    for (let i = 0; i < this.months.length; i++) {
      if (this.months[i].checked) {
        checkedCount++;
        if (checkedCount > 4) {
          this.months[i].checked = false;
        }
      }
    }
  }

  selectMonth(event, selectedMonth) {
    const isCheck = event.checked;
    let checkCount = this.months.filter((res)=> res.checked);
    this.months.filter((res) => {

      if (event.checked && res.name === selectedMonth.name && res.year === selectedMonth.year) {
        if (this.selectedMonthCount < 4) {

          res.checked = true;
          this.selectedMonthCount++;
        } else {
          event.source.checked = false;
        }
      } else if (!event.checked && res.name === selectedMonth.name && res.year === selectedMonth.year) {
        if (this.selectedMonthCount > 1) {
          res.checked = false;
          this.selectedMonthCount--;
        } else {
          event.source.checked = true;
        }
      }
    });
    this.setMonthlyDate(((event.source.checked || !isCheck) && this.selectedWeekCount >= 1 ) && !(checkCount.length == 1 && isCheck == false));
  }

  setMonthlyDate(isValid) {
    this.dates = [];
    this.legends = [];
    this.months.forEach((res: any, i: any) => {
      if (res?.checked) {
        let monthlyDates = new Date(
          new Date(res.year, res.monthNumber, 1).setHours(0, 0, 0, 0) -
            new Date(res.year, res.monthNumber + 1, 0).getTimezoneOffset() *
              60000
        );

        this.legends.push({name:res.name,year:res.year});

        this.dates.push(monthlyDates);
      }
    });
    if(isValid) this.profitComparison();
  }

  // Quater

  setQuarterly() {
    this.quartely = [];
    this.selectQuaterly = [];
    let monthName = new Date().getMonth();
    let lastMonth;
    let lastYear;
    let currentDate = new Date();
    for (let i = 0; i < 4; i++) {
      this.startDate = new Date(this.date.setMonth(this.date.getMonth() - 3));
      this.currentYear = this.date.getFullYear();
      this.currentMonth = this.date.getMonth();
      if (i > 0) {
        this.year = null;
        monthName = null;
        currentDate = null;
      }
      let label =
        (this.month[monthName]
          ? this.month[monthName]
          : this.month[lastMonth]) +
        " " +
        (this.year ? this.year : lastYear) +
        "-" +
        this.month[this.currentMonth] +
        " " +
        this.currentYear;
      this.selectQuaterly.push({
        label: label,
        from: currentDate ? currentDate : this.endDate,
        to: this.startDate,
        checked: i < 4 ? true : false,
      });
      this.quartely.push({
        value: "quarter" + i,
        months: label,
        checked: i < 4 ? true : false,
      });
      lastYear = this.currentYear;
      lastMonth = this.currentMonth;
      this.endDate = this.startDate;
    }
  }

  selectQuartely(event, selectQuartely) {
    const isCheck = event.checked;
    let checkCount = this.quartely.filter((res)=> res.checked);
    this.quartely.filter((res) => {
      if (event.checked && res.months === selectQuartely.months) {
        if (this.selectedQuarterCount < 4) {
          res.checked = true;
          this.selectedQuarterCount++;
        } else {
          event.source.checked = false;
        }
      } else if (!event.checked && res.months === selectQuartely.months) {
        if (this.selectedQuarterCount > 1) {
          res.checked = false;
          this.selectedQuarterCount--;
        } else {
          event.source.checked = true;
        }
      }
    });
    this.selectQuaterly.forEach((res) => (res.checked = false));
    this.quartely.forEach((res) => {
      this.selectQuaterly.forEach((item) => {
        if (item.label == res.months && res.checked) {
          item.checked = true;
        }
      });
    });
    this.selectQuartelyDate(((event.source.checked || !isCheck) && this.selectedWeekCount >= 1 ) && !(checkCount.length == 1 && isCheck == false));
  }

  selectQuartelyDate(isValid) {
    this.dates = [];
    this.legends = [];
    this.selectQuaterly.forEach((res, i: any) => {
      if (res.checked) {
        const weeklyDates = new Date(
          res.from.setHours(0, 0, 0, 0) - res.to.getTimezoneOffset() * 60000
        ).toISOString();

        this.legends.push({name:res.label});

        this.dates.push(weeklyDates);
      }
    });    
    if(isValid) this.profitComparison();
  }

  // Year

  selectYearly(event, selectYearly) {
    const isCheck = event.checked;
    let checkCount = this.years.filter((res)=> res.checked);
    this.years.filter((res) => {
      if (event.checked && res.name === selectYearly.name) {
        if (this.selectedYearCount <= 3) {
          res.checked = true;
          this.selectedYearCount++;
        } else {
          event.source.checked = false;
        }
      } else if (!event.checked && res.name === selectYearly.name) {
        if (this.selectedYearCount > 1) {
          res.checked = false;
          this.selectedYearCount--;
        } else {
          event.source.checked = true;
        }
      }
    });
    this.setYearlyDate(((event.source.checked || !isCheck) && this.selectedWeekCount >= 1 ) && !(checkCount.length == 1 && isCheck == false));
  }

  setYearlyDate(isValid) {
    this.dates = [];
    this.legends = [];
    this.years.forEach((res: any, i: any) => {
      if (res.checked) {
        let yearlyDates = new Date(
          new Date(res.name, 0, 1).setHours(0, 0, 0, 0)
        );
        yearlyDates.setDate(yearlyDates.getDate() + 1);

        this.legends.push({name:res.name});

        this.dates.push(yearlyDates);
      }
    });
    if(isValid) this.profitComparison();
  }

  set(name) {
    this.selectedType = name;
    this.legends.forEach((ele)=>{ele.sum=0});
    this.profitComparison();
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  profitComparison() {
    this.loading = true;
    let accounts
    if (this.dates.length > 0 && this.dates.length <= 4) {
      const payload: any = {
        timeType: this.selectedDate,
        datatype: this.selectedType.split(' ').join('_').toLowerCase(),
        dates: this.dates,
      };
      this.availableFilters?.filter((res)=>{
        if(res.filterName=='Channel' && res.currentValue!=null){
            accounts= res.currentValue
        }
       })
       if(accounts) payload.account= accounts;
      this.reportService.ProfitComparison(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.isTodayFirstDayOfMonth();
          this.loading = false;
          this.mixedChartData =  [];
          this.mixedChartLabel = [];
          res.values.forEach((result,i)=>{
            this.mixedChartData.push({
              type: "spline",

              name:this.legends[i].name + (this.legends[i].year ? ' ' + this.legends[i].year :'' ),

              showInLegend: false,
              data: result.map((t) => Math.abs(t.value)).filter((x) => x != null),
              checked: true,
            });
            const sum = result.reduce((acc, t) => acc + t.value, 0);
            this.legends[i].sum = Math.trunc(Math.abs(sum));
            if(this.selectedDate == 'w'){
              this.mixedChartLabel = result.map((t) => this.datePipe.transform(t.date , 'EEEE')
              )}
            else if(this.selectedDate == 'm'){
              this.generateDays();
            }
          });
          if(this.isFirstDayOfMonth && this.selectedType==='m'){
            this.mixedChartData.splice(0, 1, {
              type: "spline",
              showInLegend: false,
              data: [0,0,0],
              checked: true,
            });
            this.mixedChartData.forEach((ele,i)=>{

              this.mixedChartData[i].name=this.legends[i].name + (this.legends[i].year ? ' ' + this.legends[i].year :'' );

             })
         }
        },
       error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
          }
        }
      );
    }
  }

  generateDays(): void {
    let days: any[] = [];
    for (let i = 1; i <= 31; i++) {
      days.push(i);
    }
   this.mixedChartLabel= days;
  }

  isTodayFirstDayOfMonth() {
    const today = new Date();
    this.isFirstDayOfMonth = today.getDate() === 1;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
